import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["href", "children", "active", "onClick", "selected", "neutral"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Fragment, forwardRef, useMemo } from 'react';
import { Avatar } from 'flowbite-react';
import { Menu as HeadlessMenu, Transition } from '@headlessui/react';
import { openInNewTab, useNavigationContext, useResponsiveBreakPoints } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var placeholderAvatar = /*#__PURE__*/_jsx(Avatar, {
  alt: "",
  onClick: function onClick() {
    return openInNewTab("/profilo");
  },
  placeholderInitials: "",
  size: "md",
  rounded: true
});

export var Dropdown = function Dropdown(_ref) {
  var menuItemList = _ref.menuItemList,
      buttonEl = _ref.buttonEl,
      onClick = _ref.onClick,
      selectedValue = _ref.selectedValue,
      children = _ref.children,
      headerItemsCustomStyles = _ref.headerItemsCustomStyles;
  return /*#__PURE__*/_jsxs(HeadlessMenu, {
    as: "div",
    className: "relative inline-block",
    children: [/*#__PURE__*/_jsx(HeadlessMenu.Button, {
      className: "inline-flex w-full justify-center rounded-md bg-opacity-20 py-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 z-[1.5] ".concat(!buttonEl ? 'bg-black' : ''),
      children: buttonEl || placeholderAvatar
    }), menuItemList !== null && menuItemList !== void 0 && menuItemList.length || children ? /*#__PURE__*/_jsx(Transition, {
      as: Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95",
      children: /*#__PURE__*/_jsx(HeaderItemsStyled, {
        headerItemsCustomStyles: headerItemsCustomStyles,
        children: /*#__PURE__*/_jsx("div", {
          className: "px-1 py-1",
          children: menuItemList ? menuItemList.map(function (item) {
            return /*#__PURE__*/_jsx(MenuItem, {
              item: item,
              selectedValue: selectedValue,
              onClick: onClick
            }, item.key);
          }) : children
        })
      })
    }) : null]
  });
};

var HeaderItemsStyled = /*#__PURE__*/_styled(HeadlessMenu.Items).withConfig({
  displayName: "dropdown__HeaderItemsStyled",
  componentId: "sc-1905exb-0"
})(["", ";", ""], {
  "position": "absolute",
  "top": "48px",
  "right": "0px",
  "zIndex": "10",
  "marginTop": "1rem",
  "minWidth": "100%",
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
  "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
  "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
  "--tw-ring-opacity": "0.05",
  "--tw-ring-color": "rgb(28 19 39 / var(--tw-ring-opacity))"
}, function (_ref2) {
  var headerItemsCustomStyles = _ref2.headerItemsCustomStyles;
  return headerItemsCustomStyles;
});

export var NextLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useNavigationContext = useNavigationContext(),
      Link = _useNavigationContext.linkComponent;

  var href = props.href,
      children = props.children,
      active = props.active,
      handleClick = props.onClick,
      selected = props.selected,
      neutral = props.neutral,
      rest = _objectWithoutProperties(props, _excluded);

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var activeClassFn = useMemo(function () {
    return "".concat(active ? 'bg-purple-500 text-white' : selected ? 'bg-purple-100 text-gray-900' : neutral ? 'bg-white' : 'text-gray-900', " group flex w-full items-center rounded-md px-2 py-2 text-sm");
  }, [active, neutral, selected]);
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    target: isDesktop && href !== '#!' ? '_blank' : '_self',
    onClick: function onClick(e) {
      if (handleClick) handleClick(e);
    },
    children: /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      className: activeClassFn,
      ref: ref
    }, rest), {}, {
      children: children
    }))
  });
});

function MenuItem(_ref3) {
  var item = _ref3.item,
      selectedValue = _ref3.selectedValue,
      _onClick = _ref3.onClick,
      _children = _ref3.children;
  var isCustomItem = !!_children;
  return /*#__PURE__*/_jsx(HeadlessMenu.Item, {
    children: function children(_ref4) {
      var active = _ref4.active;
      return /*#__PURE__*/_jsx(NextLink, {
        selected: isCustomItem ? undefined : selectedValue === item.value,
        href: item.url ? item.url : '#!',
        onClick: function onClick() {
          var _item$onClick;

          !!_onClick && _onClick(item.value);
          item === null || item === void 0 ? void 0 : (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item);
        },
        neutral: isCustomItem,
        active: isCustomItem ? undefined : active,
        children: /*#__PURE__*/_jsx("div", {
          className: "min-w-[max-content]",
          children: _children || item.label
        })
      });
    }
  }, item.key);
}

Dropdown.MenuItem = MenuItem;